import React from "react";
import Button from "react-bootstrap/Button";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Components from "./Components.js";
import Embedded from "./Embedded.js";
import Icon from "./icon.js";
import "./styles.css";

export default function App() {
  return (
    <Container fluid style={{ width: "100%" }}>
      <Row style={{ height: "100vh" }}>
        <Col sm={6}>
          <Embedded />
        </Col>
        <Col sm={6}>
          <div style={{ height: "100%", width: "100%", background: "#1E1B1C" }}>
            <div className={"text-center"}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "25%"
                }}
              >
                <Icon />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "space-between",
                marginTop: "2%"
              }}
            >
              <Components />
            </div>
            <div className="text-center">
              <Button
                variant="danger"
                href="https://customizer-fenderfy.netlify.app"
              >
                GET STARTED
              </Button>
            </div>
          </div>

          <div
            style={{ height: "100%", width: "100%", background: "#E6E6E4" }}
          ></div>
        </Col>
      </Row>
    </Container>
  );
}
